import { AccountEntity } from "@goodfill/domain-entities";
import { asAccountId } from "@goodfill/domain-properties";
import { Account } from "../API";

export function accountApiToModel(apiAccount: Account): AccountEntity {
  return {
    id: asAccountId(apiAccount.id),
  };
}
